import { ExportDataEntityEnum } from '../../../../shared/models';
import { PropertyTypeEnum } from '../../../../shared/properties';
import { generateViewColumnKeyFromMapping, ViewColumn } from '../../view';
import { individualViewColumnDefinition } from '../../view/individual-view-column.definition';
import {
  ExportColumnDefinition,
  ExtractKeys,
} from './export-data-column.definition';

export const INDIVIDUAL_EXPORT_DATA_COLUMN_KEYS = [
  'individual_id',
  'individual_roles',
  'individual_first_name',
  'individual_last_name',
  'individual_middle_name',
  'individual_maiden_name',
  'individual_email',
  'individual_birth_date',
  'individual_birth_country',
  'individual_birth_place',
  'individual_address_street_address',
  'individual_address_street_address_2',
  'individual_address_city',
  'individual_address_state',
  'individual_address_region',
  'individual_address_country',
  'individual_banking_information_iban',
  'individual_banking_information_bic',
  'individual_tax_identification_number',
  'individual_social_security_number',
  'individual_phone_number',
  'individual_position',
  'individual_ownership_percentage',
  'individual_is_beneficial_owner',
  'individual_is_business_contact',
  'individual_created_at',
  'individual_updated_at',
] as const;

// Type-safe keys type
export type IndividualExportDataColumnKey = ExtractKeys<
  typeof INDIVIDUAL_EXPORT_DATA_COLUMN_KEYS
>;

export const individualExportDataColumnDefinitionMap: Record<
  IndividualExportDataColumnKey,
  ViewColumn<PropertyTypeEnum, PropertyTypeEnum>
> = {
  individual_id: individualViewColumnDefinition.id,
  individual_roles: individualViewColumnDefinition.roles,
  individual_first_name: individualViewColumnDefinition.firstName,
  individual_last_name: individualViewColumnDefinition.lastName,
  individual_middle_name: individualViewColumnDefinition.middleName,
  individual_maiden_name: individualViewColumnDefinition.maidenName,
  individual_email: individualViewColumnDefinition.email,
  individual_birth_date: individualViewColumnDefinition.birthDate,
  individual_birth_country: individualViewColumnDefinition.birthCountry,
  individual_birth_place: individualViewColumnDefinition.birthPlace,
  individual_address_street_address:
    individualViewColumnDefinition['address.streetAddress'],
  individual_address_street_address_2:
    individualViewColumnDefinition['address.streetAddress2'],
  individual_address_city: individualViewColumnDefinition['address.city'],
  individual_address_state: individualViewColumnDefinition['address.state'],
  individual_address_region: individualViewColumnDefinition['address.region'],
  individual_address_country: individualViewColumnDefinition['address.country'],
  individual_banking_information_iban:
    individualViewColumnDefinition['bankingInformation.iban'],
  individual_banking_information_bic:
    individualViewColumnDefinition['bankingInformation.bic'],
  individual_tax_identification_number:
    individualViewColumnDefinition.taxIdentificationNumber,
  individual_social_security_number:
    individualViewColumnDefinition.socialSecurityNumber,
  individual_phone_number: individualViewColumnDefinition.phoneNumber,
  individual_position: individualViewColumnDefinition.position,
  individual_ownership_percentage:
    individualViewColumnDefinition.ownershipPercentage,
  individual_is_beneficial_owner:
    individualViewColumnDefinition.isBeneficialOwner,
  individual_is_business_contact:
    individualViewColumnDefinition.isBusinessContact,
  individual_created_at: individualViewColumnDefinition.createdAt,
  individual_updated_at: individualViewColumnDefinition.updatedAt,
};

export const individualViewColumnKeyToExportColumnKey: Record<
  string,
  IndividualExportDataColumnKey
> = Object.entries(individualExportDataColumnDefinitionMap).reduce(
  (acc, [key, { mapping }]) => {
    acc[generateViewColumnKeyFromMapping(mapping)] =
      key as IndividualExportDataColumnKey;
    return acc;
  },
  {} as Record<string, IndividualExportDataColumnKey>,
);

export const individualExportDataColumnDefinition: ExportColumnDefinition<IndividualExportDataColumnKey>[] =
  INDIVIDUAL_EXPORT_DATA_COLUMN_KEYS.map((individualColumnKey) => ({
    uniqueKey: individualColumnKey,
    sourceEntity: ExportDataEntityEnum.individual,
    viewColumn: individualExportDataColumnDefinitionMap[individualColumnKey],
  }));
